<template>
  <ListFilterForm
    :is-filter-enabled="props.isFilterEnabled"
    :initial-filter="initialFilter"
    :has-local="true"
    :base-filter="baseFilter"
    @toggle-filter="emits('toggleFilter')"
    @set-filter="setParentFilter"
    @update-local-filter="setLocalFilter"
  >
    <template #fields="slotProps">
      <div class="flex flex-col">
        <label for="date" class="small-label">Организация</label>
        <CatalogDataSingleInput
          :useIdOnly="true"
          selectType="organization"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.organization"
          @update:modelValue="
            ($event) => {
              slotProps.filter.organization = $event;
              slotProps.filter.department = [];
              slotProps.filter.role = [];
            }
          "
        ></CatalogDataSingleInput>
      </div>
      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Департамент</label>
        <MultiSelect
          v-model="slotProps.filter.department"
          optionLabel="name"
          :options="departments"
          optionValue="id"
          :disabled="slotProps.filter.organization == null"
          placeholder="Выберите значение"
          @update:modelValue="
            ($event) => {
              slotProps.filter.role = [];
            }
          "
          filter
          showClear
        ></MultiSelect>
      </div>

      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Роль</label>
        <MultiSelect
          v-model="slotProps.filter.role"
          optionLabel="name"
          :options="getRoles()"
          optionValue="id"
          :disabled="
            slotProps.filter.department.length == 0 ||
            slotProps.filter.organization == null
          "
          placeholder="Выберите значение"
          filter
          showClear
        ></MultiSelect>
      </div>
    </template>
  </ListFilterForm>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";

import MultiSelect from "primevue/multiselect";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";

import { useOrganizationsDictionaryStore } from "@/store/catalog_data/organizations";
import { Department } from "@/store/dictionaries/organizations";

const props = defineProps<{
  isFilterEnabled: boolean;
  baseOrganization: number;
}>();
const emits = defineEmits(["toggleFilter", "setFilter"]);
const orgDictionaryStore = useOrganizationsDictionaryStore();
const departments = ref([] as Department[]);
const localFilter = ref<any>(null);

const initialFilter = {
  organization: null as number | null,
  department: [] as number[],
  role: [] as number[],
};

const baseFilter = ref({
  organization: null as number | null,
  department: [] as number[],
  role: [] as number[],
});

watch(
  () => orgDictionaryStore.itemList,
  () => {
    setDepartments();
  }
);

watch(
  () => props.baseOrganization,
  () => {
    baseFilter.value.organization = props.baseOrganization;
    // setLocalFilter(baseFilter);
  }
);

onMounted(() => {
  setLocalFilter(baseFilter);
});

const setDepartments = () => {
  if (localFilter.value && localFilter.value.organization) {
    const foundItem = orgDictionaryStore.itemList.find(
      (item) => item.id === localFilter.value.organization
    );
    if (foundItem) {
      departments.value = foundItem.departments;
      return;
    }
  }
  departments.value = [];
};

const getRoles = () => {
  let roles: any[] = [];
  if (localFilter.value && localFilter.value.department && departments.value) {
    departments.value.forEach((item) => {
      if (localFilter.value.department.includes(item.id) && item.roles) {
        roles = [...roles, ...item.roles];
      }
    });
  }
  return roles;
};

const setLocalFilter = (filter: any) => {
  localFilter.value = filter;
  setDepartments();
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};
</script>
